import {config} from '../Config';

import {BaseSearchableService} from "./Core/BaseSearchableService";
import {BaseService} from "./Core/BaseService";

class PermitService extends BaseSearchableService {
    get Url() { return super.Url + "/permits"; }
    get ModelName() { return "Permit"; }
    get PrimaryKeyProperty() { return "permitId"; }
    get TitleProperty() { return "permitNumber"; }
    get Request() {
        const organizationId = config.getStore().getState().contextState?.organizationId;

        return {...super.Request, organizationId};
    }
    
    GetTitle(permit, defaultTitle = "") {
        const permitOrg = permit?.PermitType?.PermitOrganization?.abbreviation ?? permit?.PermitType?.PermitOrganization?.shortName ?? permit?.PermitType?.PermitOrganization?.name ?? '';
        const permitType = permit?.PermitType?.shortName ?? permit?.PermitType?.name ?? '';
        return `${permitOrg} ${permitType} ${permit?.permitNumber ?? defaultTitle}`.trim();
    }

    GetModel(permitId) {
        return this.SendRequest(BaseService.GET, permitId);
    }
    
    CreateModel(permit) {
        this.FlushCache();
        return this.SendRequest(BaseService.POST, permit);
    }
    
    UpdateModel(permit) {
        this.FlushCache();
        return this.SendRequest(BaseService.PUT, permit);
    }
    
    DeleteModel(permitId) {
        this.FlushCache();
        return this.SendRequest(BaseService.DELETE, permitId);
    }

    GetPermitsForContext(contextNodeId) {
        return this.SendRequest(BaseService.GET, {contextNodeId});
    }
}

export const service = new PermitService();

